import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { typeWeeklyMission, subTypeInAppMission, missionScores } from '../../constants/constants';
import { dateToFullDateTime, stringToDate } from '../../utils/DateUtil';
const refModalImages = React.createRef();
const refModal = React.createRef();

function NewWeeklyMission(props) {
  const { firestore, edit, mission, images, companies = [] } = props;
  const [companyId, setCompanyId] = useState('');
  const [description, setDescription] = useState('');
  const [name, setName] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [bonusPyns, setBonusPyns] = useState(0);
  const [redirecToWeeklyMissionsList, setRedirecToWeeklyMissionsList] = useState(false);
  const [activated, setActivated] = useState(false);
  const [inAppMission, setInAppMission] = useState({ description: '', quantity: 0, type: typeWeeklyMission.inApp, subtype: '' });
  const [sponsorMission, setSponsorMission] = useState({ description: '', quantity: 0, type: typeWeeklyMission.sponsor, uidCompany: '' });
  const [educationMission, setEducationMission] = useState({ description: '', quantity: 1, type: typeWeeklyMission.education, url: '' });
  const [notificationIcon, setNotificationIcon] = useState('');
  const [searchName, setSearchName] = useState('');
  const [currentCompanies, setCurrentCompanies] = useState([]);
  
  useEffect(() => {
    const setWeeklyMission = (mission) => {
      if (mission) {
        setMissionFields(mission);
        mission.missions.forEach((m) => setMission(m));
      }
    };

    setWeeklyMission(mission);
  }, [mission]);

  const setMissionFields = mission => {
    if (mission.idCompany) {
      setCompanyId(mission.idCompany);
    }
    setName(mission.name);
    setDescription(mission.description);
    setStartDate(dateToFullDateTime(mission.startDate.toDate()));
    setEndDate(dateToFullDateTime(mission.endDate.toDate()));
    setBonusPyns(mission.bonusPyns);
    setActivated(mission.activated);
    setNotificationIcon(mission.notificationIcon || '');
  }

  const setMission = (mission) => {
    switch (mission.type) {
      case typeWeeklyMission.inApp:
        setInAppMission(mission);
        break;
      case typeWeeklyMission.sponsor:
        setSponsorMission(mission);
        break;
      case typeWeeklyMission.education:
        setEducationMission(mission);
        break;
      default:
        break;
    }
  };

  useEffect(() => M.AutoInit(), [inAppMission]);

  useEffect(() => M.updateTextFields());

  useEffect(() => setCurrentCompanies(companies), [companies]);

  const createWeeklyMission = () => {
    if (!validateWeeklyMission()) {
      alert('Please fill in all the minimum fields');
      return;
    }
    const newWeeklyMission = {
      updatedAt: firestore.FieldValue.serverTimestamp(),
      name,
      description,
      startDate: stringToDate(startDate),
      endDate: stringToDate(endDate),
      bonusPyns: Number(bonusPyns),
      activated,
      idCompany: companyId,
      missions: [inAppMission, companyId ? { ...sponsorMission, uidCompany: companyId } : sponsorMission, educationMission],
      notificationIcon,
    };
    saveWeeklyMission(newWeeklyMission);
  };

  const validateWeeklyMission = () =>
    name.trim() !== '' && startDate.trim() !== '' && endDate.trim() !== '' && inAppMission.description.trim() !== '' && inAppMission.subtype.trim() !== '' && sponsorMission.description.trim() !== '' && educationMission.description.trim() !== '' && educationMission.url.trim() !== '';

  const saveWeeklyMission = (newWeeklyMission) => {
    const query = generateQuery(newWeeklyMission);
    query.then(() => setRedirecToWeeklyMissionsList(true)).catch((error) => console.error(error));
  };

  const generateQuery = (newMission) => {
    let query = firestore.collection('weeklyMission');
    if (edit) {
      query = query.doc(mission.id).set(newMission, { merge: true });
    } else {
      const newRef = query.doc();
      query = newRef.set({ uid: newRef.id, ...newMission });
    }
    return query;
  };

  const openCompanyDialog = () => M.Modal.getInstance(refModal.current).open();

  const filterCompanies = (companyName) => {
    if (!companies) return;
    let filteredCompanies = companies.filter((company) => {
      return companyName !== '' ? company.companyName.toLowerCase().includes(companyName.toLowerCase()) : true;
    });
    setCurrentCompanies(filteredCompanies);
  };

  const search = (searchTerm) => {
    setSearchName(searchTerm);
    filterCompanies(searchTerm);
  };

  const renderCompanyDialog = () => {
    return (
      <div ref={refModal} className="modal">
        <div className="modal-content">
          <h5>Company ID</h5>
          <div className="row">
            <div className="input-field col s12">
              <input id="searchName" type="text" className="validate" value={searchName} onChange={(e) => search(e.target.value)} />
              <label htmlFor="searchName">Company name</label>
            </div>
          </div>
          <div className="search-container">{currentCompanies.map((company) => renderCompany(company))}</div>
        </div>
        <div className="modal-footer">
          <div className="modal-close waves-effect btn btn-flat" onClick={() => search('')}>
            Cancel
          </div>
        </div>
      </div>
    );
  };

  const renderCompany = (company) => (
    <div key={company.id}>
      <div
        onClick={() => {
          setCompanyId(company.uid);
          search('');
        }}
        className="modal-close waves-effect btn btn-flat">
        {company.companyName}
      </div>
    </div>
  );

  const renderDateTimePicker = (label, field, setter) => (
    <div className="col s6">
      <label htmlFor="contestTime">{label}</label>
      <input type="datetime-local" id="contestTime" name="contestTime" value={field}
        onChange={(e) => setter(dateToFullDateTime(e.target.value))} />
    </div>
  );

  const renderActivated = () => (
    <div className="input-field col s6">
      Activated:
      <div className="row">
        <div className="input-field col s6">
          <label>
            <input name="group1" type="radio" checked={!activated} onChange={() => setActivated(false)} />
            <span>No</span>
          </label>
        </div>
        <div className="input-field col s6">
          <label>
            <input name="group2" type="radio" checked={activated} onChange={() => setActivated(true)} />
            <span>Yes</span>
          </label>
        </div>
      </div>
    </div>
  );

  const renderSubTypeSelect = () => {
    return (
      <div className="input-field col s4">
        <select
          value={inAppMission.subtype}
          onChange={(e) => {
            const newMission = { ...inAppMission, subtype: e.target.value };
            if (!missionNeedsScore(newMission.subtype)) delete newMission.score;
            setInAppMission(newMission);
          }}>
          <option value="" disabled>
            Choose subtype
          </option>
          {Object.keys(subTypeInAppMission).map((subtype) => (
            <option key={subtype} value={subtype}>
              {subTypeInAppMission[subtype]}
            </option>
          ))}
        </select>
        <label>Subtypes</label>
      </div>
    );
  };

  const missionNeedsScore = (subtype) => missionScores.includes(subtype);

  const renderInAppMission = () => (
    <div>
      <h5 style={{ marginBottom: 30 }}>In-App Mission</h5>
      <div className="row">
        <div className="input-field col s12">
          <textarea id="d1" className="materialize-textarea" value={inAppMission.description} onChange={(e) => setInAppMission({ ...inAppMission, description: e.target.value })} style={{ marginTop: 10 }} />
          <label htmlFor="d1" className="active">
            Description
          </label>
        </div>
      </div>
      <div className="row">
        <div className="input-field col s4">
          <input id="q1" type="number" className="validate" value={inAppMission.quantity} onChange={(e) => setInAppMission({ ...inAppMission, quantity: Number(e.target.value) })} />
          <label htmlFor="q1" className="active">
            Quantity
          </label>
        </div>
        {renderSubTypeSelect()}
        {missionNeedsScore(inAppMission.subtype) && (
          <div className="input-field col s4">
            <input id="s1" type="number" className="validate" value={inAppMission.score || 0} onChange={(e) => setInAppMission({ ...inAppMission, score: Number(e.target.value) })} />
            <label htmlFor="s1" className="active">
              Score
            </label>
          </div>
        )}
      </div>
      <div className="row"></div>
    </div>
  );

  const renderSponsorMission = () => (
    <div>
      <h5 style={{ marginBottom: 30 }}>Sponsor Mission</h5>
      <div className="row" style={{ display: 'flex', alignItems: 'center' }}>
        <div className="input-field col s9">
          <textarea id="d2" className="materialize-textarea" value={sponsorMission.description} onChange={(e) => setSponsorMission({ ...sponsorMission, description: e.target.value })} style={{ marginTop: 10 }} />
          <label htmlFor="d2" className="active">
            Description
          </label>
        </div>
        <div className="input-field col s3">
          <input id="q2" type="number" className="validate" value={sponsorMission.quantity} onChange={(e) => setSponsorMission({ ...sponsorMission, quantity: Number(e.target.value) })} />
          <label htmlFor="q2" className="active">
            Quantity
          </label>
        </div>
      </div>
      <div className="row">
        <div className="input-field">
          <div className="col s6">
            <label htmlFor="company_uid">Company ID</label>
            <input id="company_uid" type="text" name="uidCompany" value={companyId} onChange={(e) => setCompanyId(e.target.value)} />
          </div>
          <div className="col s6">
            <div className="btn btn-medium" onClick={() => openCompanyDialog()}>
              Select company
            </div>
          </div>
        </div>
      </div>
      <p className="company-address">* Leave Company ID unspecified to collect any pyns regardless of company.</p>
    </div>
  );

  const renderEducationMission = () => (
    <div>
      <h5 style={{ marginBottom: 30 }}>Education Mission</h5>
      <div className="row">
        <div className="input-field col s12">
          <textarea id="d3" className="materialize-textarea" value={educationMission.description} onChange={(e) => setEducationMission({ ...educationMission, description: e.target.value })} style={{ marginTop: 10 }} />
          <label htmlFor="d3" className="active">
            Description
          </label>
        </div>
      </div>
      <div className="row">
        <div className="input-field col s12">
          <input id="video" type="text" className="validate" value={educationMission.url} onChange={(e) => setEducationMission({ ...educationMission, url: e.target.value })} />
          <label htmlFor="video" className="active">
            Video URL
          </label>
        </div>
      </div>
    </div>
  );

  const openImageDialog = () => M.Modal.getInstance(refModalImages.current).open();

  const closeImagesModal = () => {
    const modal = document.getElementById('modalImages');
    M.Modal.getInstance(modal).close();
  };

  const renderImagesDialog = () => {
    return (
      <div ref={refModalImages} id="modalImages" className="modal">
        <div className="modal-content">{renderImages()}</div>
      </div>
    );
  };

  const renderImages = () =>
    !images ? null : (
      <div>
        <h5>Select an image:</h5>
        <div className="row">{Object.keys(images).map((imageId) => image(imageId, images))}</div>
      </div>
    );

  const image = (imageId, images) => (
    <div
      key={imageId}
      className="col s2"
      onClick={() => {
        setNotificationIcon(images[imageId].url);
        closeImagesModal();
      }}>
      <img src={images[imageId].url} width="100" height="100" alt="" />
      <br />
    </div>
  );

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;
  if (redirecToWeeklyMissionsList) return <Redirect to="/weeklyMissions" />;

  return (
    <div className="container">
      <div className="card z-depth-2 project-summary">
        <form className="col s12 new-form">
          <div className="card-content">
            <div className="row">
              <h3>{`${edit ? 'Edit' : 'New'} Weekly Mission`}</h3>
            </div>
            {renderImagesDialog()}
            <div className="row">
              <div className="input-field col s12">
                <input id="name" type="text" className="validate" value={name} onChange={(e) => setName(e.target.value)} />
                <label htmlFor="name" className="active">
                  Name
                </label>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <textarea id="description" className="materialize-textarea" value={description} onChange={(e) => setDescription(e.target.value)} style={{ marginTop: 10 }} />
                <label htmlFor="description" className="active">
                  Description
                </label>
              </div>
            </div>
            <div className="row">
              {renderDateTimePicker('Start date:', startDate, setStartDate)}
              {renderDateTimePicker('End date:', endDate, setEndDate)}
            </div>
            <div className="row">
              <div className="input-field col s6">
                <input id="bonusPyns" type="number" className="validate" value={bonusPyns} onChange={(e) => setBonusPyns(e.target.value)} />
                <label htmlFor="bonusPyns" className="active">
                  Bonus pyns
                </label>
              </div>
              {renderActivated()}
            </div>
            <div className="row">
              {notificationIcon ? <img className="col s1" src={notificationIcon} alt="" /> : null}
              <div className={`input-field col s${notificationIcon ? 11 : 12}`}>
                <input id="notificationIcon" type="text" value={notificationIcon} onChange={() => { }} onClick={() => openImageDialog()} />
                <label htmlFor="notificationIcon" className="active">
                  Notification icon
                </label>
              </div>
            </div>
            {inAppMission && renderInAppMission()}
            {sponsorMission && renderSponsorMission()}
            {educationMission && renderEducationMission()}
          </div>
          {renderCompanyDialog()}
          <div className="card-action">
            <div className="waves-effect waves-light btn btn-large" onClick={createWeeklyMission}>
              {edit ? 'Update' : 'Create'}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.firebase.auth,
    mission: ownProps.location.mission,
    edit: ownProps.location.edit,
    images: state.firestore.data['images'],
    companies: state.firestore.ordered.companies,
  };
};

export default compose(
  firestoreConnect([
    { collection: 'images', where: ['tags', 'array-contains', 'weeklyMission'], storeAs: 'images' },
    { collection: 'companies', orderBy: ['companyName', 'asc'] },
  ]),
  connect(mapStateToProps),
)(NewWeeklyMission);
